import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./index.css";
import VueGtag from "vue-gtag"; // or "vue-gtag" depending on what you installed

const app = createApp(App);

const thankYouPaths = ["/thank-you/", "/thank-you"];

// Initialize Gtag only for thank-you page
if (thankYouPaths.includes(window.location.pathname)) {
    app.use(VueGtag, {
        config: {
            id: "AW-17329110087", // <-- your active Gtag ID
        },
    }, router);
}

app.use(store).use(router).mount("#app");
